import React, { Fragment } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';

import ModalConfirm from '../modal/modalConfirm';

import data_criticity from 'src/data/criticity';
import data_priority from 'src/data/priority';
import data_ticket_state from 'src/data/ticket-state';
import ModalTaskPost from '../modal/modalTaskPost';
import ModalAppointmentPost from '../modal/modalAppointmentPost';
import ModalReminderPost from '../modal/modalReminderPost';
import ModalNotePost from '../modal/modalNotePost';
import ModalTicketClose from '../modal/modalTicketClose';
import { appendGraphQlPlanning } from 'src/utils/utilPlanning';
import MyPlanning from '../../appPlanning/myPlanning';
import InputUpdate from '../input/inputUpdate';
import TextAreaUpdate from '../input/textareaUpdate';
import InputEmployeeUpdate from '../input/inputEmployeeUpdate';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiTicketShow = '/api/ticket/show/';
const linkToCustomer = '/dashboard/customer/';
const linkToDeal = '/dashboard/deal/';
const linkToContact = '/dashboard/contact/';
const linkToUser = '/dashboard/user/';
const apiGetSupplierVirtual = '/api/supplierVirtual/';
const apiGetSupplierHardware = '/api/supplierHardware/';
const apiDealType = '/api/dealType/';
const apiIncidentType = '/api/incidentType/';
const apiDomainType = '/api/domains/';

const apiTask = '/api/task/';
const apiAppointment = '/api/appointment/';
const apiReminder = '/api/reminder/';
const apiNote = '/api/note/';

class DisplayTicket extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notFound: false,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalTicketCloseOpen: false,
      isModalTicketChangeOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      toAssociate: {
        type: 'ticket',
      },
      textModal: {
        title: undefined,
        message: undefined,
      },
      ticketChangeGraphKey: undefined,
      ticketChangeNewState: undefined,
      ticketId: undefined,
      subject: '____',
      status: undefined,
      criticity: undefined,
      priority: undefined,
      comment: '____',
      dateCreate: '____',
      isClosed: undefined,
      closingDate: undefined,
      supplier: undefined,
      creator: undefined,
      urlSupplierTicket: 'Non renseigné',
      productType: undefined,
      supplierOfProduct: undefined,
      incidentType: undefined,
      dataProductTypes: undefined,
      dataSuppliers: undefined,
      domainTypes: undefined,
      domainId: undefined,
      dataIncidentTypes: undefined,
      dateLastUpdate: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.handleTicketChange = this.handleTicketChange.bind(this);
    this.changeTicketState = this.changeTicketState.bind(this);
    this.closeTicket = this.closeTicket.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openModalTicketChange = this.openModalTicketChange.bind(this);
    this.openModalTicketClose = this.openModalTicketClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.postResult = this.postResult.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleTicketChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let graphKey;

    switch (name) {
      case 'status':
        graphKey = 'state';
        break;
      case 'criticity':
        graphKey = 'criticity';
        break;
      case 'priority':
        graphKey = 'priority';
        break;
      case 'incidentType':
        graphKey = 'incidentTypeId';
        break;
      case 'productType':
        graphKey = 'productTypeId';
        break;
      case 'domainId':
        graphKey = 'domainId';
        break;
      case 'supplierOfProduct':
        graphKey = 'supplierOfProductId';
        break;
    }
    this.openModalTicketChange(graphKey, value);
  }

  filterDealTypesByDomain = (dealTypes = [], domainId) => {
    if (!domainId) {
      return dealTypes;
    }
    return dealTypes.filter((dealType) => (dealType.domain || {}).id === domainId);
  };

  filterSupplierByDomain = (suppliers = [], domainId) => {
    if (!domainId) {
      return suppliers;
    }
    return suppliers.filter((supplier) => (supplier.domain || {}).id === domainId);
  };

  getDataSuppliersHardware() {
    let queryURL = apiGetSupplierHardware;
    let graphQL = '{suppliersHardware{id, name, domain{id, name}}}';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['suppliersHardware']) {
            this.setState({
              dataSuppliersHardware: data['data']['suppliersHardware'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('error fetch supplier hardware list :\n' + error);
        }.bind(this)
      );
  }

  deleteCollaborative = (id, type) => {
    let json = { [type]: { id } };

    let collaborative = {
      type: undefined,
      message: undefined,
      apiUrl: undefined,
    };

    let afterView = 1;
    switch (type) {
      case 'task':
        collaborative.type = 'task';
        collaborative.message = 'tâche';
        collaborative.apiUrl = apiTask;
        afterView = 1;
        break;
      case 'appointment':
        collaborative.type = 'appointment';
        collaborative.message = 'rendez-vous';
        collaborative.apiUrl = apiAppointment;
        afterView = 2;
        break;
      case 'reminder':
        collaborative.type = 'reminder';
        collaborative.message = 'rappel';
        collaborative.apiUrl = apiReminder;
        afterView = 3;
        break;
      case 'note':
        collaborative.type = 'note';
        collaborative.message = 'note';
        collaborative.apiUrl = apiNote;
        afterView = 4;
        break;
    }

    let queryURL = collaborative.apiUrl;
    let tabParam = encodeURIComponent(JSON.stringify(json));
    queryURL += tabParam;

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.isValid) {
          this.componentDidMount();
          this.setState({ selectedView: afterView });
          this.props.openToast(true, 'Suppression réalisée ');
        } else {
          this.props.openToast(false, 'Erreur suppression. Veuillez réessayer');
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.openToast(false, 'Impossible à supprimer');
      });
  };

  getDataSuppliersVirtual() {
    let queryURL = apiGetSupplierVirtual;
    let graphQL = '{ suppliersVirtual{id, name, domain{id, name}} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['suppliersVirtual']) {
            this.setState({
              dataSuppliersVirtual: data['data']['suppliersVirtual'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('error fetch supplier list :\n' + error);
        }.bind(this)
      );
  }

  getDealTypes() {
    let queryURL = apiDealType;
    let graphQL = '{ dealTypes{id, name, domain{id, name}} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataProductTypes: data['data']['dealTypes'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch deal types');
        }.bind(this)
      );
  }

  getIncidentTypes() {
    let queryURL = apiIncidentType;
    let graphQL = '{ incidentTypes{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataIncidentTypes: data['data']['incidentTypes'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch deal types');
        }.bind(this)
      );
  }

  getDomainTypes() {
    let queryURL = apiDomainType;
    let graphQL = '{ domains{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            domainTypes: data['data']['domains'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch domain types');
        }.bind(this)
      );
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiTicketShow;
      let graphQL =
        '{ ticket(id:' +
        paramsID +
        '){ id, subject, closed, closingDate, dateCreate, state, criticity, priority, urlSupplierTicket, comment, dateLastUpdate ' +
        'creator{ user{ id, username } }, ' +
        'supportEmployee{ user{ id, username } }, ' +
        'associatedContact{ id, name, lastname}, ' +
        'customer{ id, installationSite{ socialReason } }, ' +
        'stepSupport{ deal{ id, name } }, ' +
        'supplier{ id, name}, ' +
        'supplierOfProduct {id, name}, ' +
        'incidentType {id, name}, ' +
        'domain {id, name}, ' +
        'productType{id, name} ' +
        appendGraphQlPlanning() +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['ticket']) {
              let toAssociate = this.state.toAssociate;
              toAssociate['id'] = data['data']['ticket']['id'];
              toAssociate['name'] = data['data']['ticket']['subject'];
              this.setState({
                toAssociate: toAssociate,
                ticketId: data['data']['ticket']['id'],
                productType: data['data']['ticket']['productType'],
                supplierOfProduct: data['data']['ticket']['supplierOfProduct'],
                incidentType: data['data']['ticket']['incidentType'],
                subject: data['data']['ticket']['subject'],
                dateCreate: data['data']['ticket']['dateCreate'],
                status: data['data']['ticket']['state'],
                criticity: data['data']['ticket']['criticity'],
                priority: data['data']['ticket']['priority'],
                urlSupplierTicket: data['data']['ticket']['urlSupplierTicket'],
                comment: data['data']['ticket']['comment'],
                isClosed: data['data']['ticket']['closed'],
                closingDate: data['data']['ticket']['closingDate'],
                supplier: data['data']['ticket']['supplier'],
                customer: data['data']['ticket']['customer'],
                contact: data['data']['ticket']['associatedContact'],
                stepSupport: data['data']['ticket']['stepSupport'],
                creator: data['data']['ticket']['creator'],
                supportEmployee: data['data']['ticket']['supportEmployee'],
                dataTask: data['data']['ticket']['tasks'],
                domainId: (data['data']['ticket']['domain'] || {})['id'] || 2,
                dataAppointment: data['data']['ticket']['appointments'],
                dataReminder: data['data']['ticket']['reminders'],
                dataNote: data['data']['ticket']['notes'],
                dateLastUpdate: data['data']['ticket']['dateLastUpdate'],
              });
            } else {
              this.setState({ notFound: true });
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch ticket entity: \n' + error);
          }.bind(this)
        );

      this.getDataSuppliersVirtual();
      this.getDataSuppliersHardware();
      this.getDealTypes();
      this.getIncidentTypes();
      this.getDomainTypes();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    const { dataSuppliersHardware = [], dataSuppliersVirtual = [], domainId } = this.state;
    if (this.state.notFound === true || !this.props.match.params.id) return null;

    let triggerTicket = {
      id: this.state.ticketId,
      name: this.state.subject,
      isClosed: this.state.isClosed,
    };

    const isGlobal = !this.state.customer;

    const dataSuppliers = dataSuppliersHardware.concat(dataSuppliersVirtual);

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Fiche Ticket'
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={this.openModalTicketClose} type='button' className='btn btn-sm btn-outline-success'>
              {this.state.isClosed ? (
                <span className='icon icon-reply'>Réouvrir</span>
              ) : (
                <span className='icon icon-check'>Clôturer</span>
              )}
            </button>
            <button onClick={() => this.openModal('task')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Tâche</span>
            </button>
            <button
              onClick={() => this.openModal('appointment')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-plus'>Rdv</span>
            </button>
            <button onClick={() => this.openModal('reminder')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Rappel</span>
            </button>
            <button onClick={() => this.openModal('note')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Note</span>
            </button>
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <div className='form-group'>
                <input value={'#' + this.state.ticketId} type='text' className='form-control' readOnly={true} />
              </div>
              <InputUpdate
                inputType={'text'}
                inputLabel={'Sujet'}
                inputValue={this.state.subject}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'subject')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              {this.state.supplier && (
                <div className='form-group'>
                  <label>Fournisseur concerné</label>
                  <input
                    name='supplier'
                    value={this.state.supplier.name}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
              )}
              {this.state.customer && (
                <div className='form-group'>
                  <label>Client concerné</label>
                  <Link to={linkToCustomer + this.state.customer.id}>
                    <input
                      name='customer'
                      value={this.state.customer.installationSite.socialReason}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              {this.state.stepSupport && (
                <div className='form-group'>
                  <label>Affaire concernée</label>
                  <Link to={linkToDeal + this.state.stepSupport.deal.id}>
                    <input
                      name='stepSupport'
                      value={this.state.stepSupport.deal.name}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              {this.state.contact && (
                <div className='form-group'>
                  <label>Contact référent</label>
                  <Link to={linkToContact + this.state.contact.id}>
                    <input
                      name='contact'
                      value={this.state.contact.name + ' ' + this.state.contact.lastname}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}

              {!isGlobal && (
                <Fragment>
                  <div className={'form-group'}>
                    <label>Domaine </label>
                    <select
                      name='domainId'
                      value={this.state.domainTypes ? this.state.domainId : 'none'}
                      onChange={this.handleTicketChange}
                      className='form-control'
                    >
                      <option disabled value={'none'} />
                      {this.state.domainTypes ? (
                        Object.entries(this.state.domainTypes).map(([key, data]) => (
                          <option key={key} value={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>

                  <div className={'form-group'}>
                    <label>Type de demande </label>
                    <select
                      name='incidentType'
                      value={this.state.incidentType ? this.state.incidentType.id : 'none'}
                      onChange={this.handleTicketChange}
                      className='form-control'
                    >
                      <option disabled value={'none'} />
                      {this.state.dataIncidentTypes ? (
                        Object.entries(this.state.dataIncidentTypes).map(([key, data]) => (
                          <option key={key} value={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>

                  <div className={'form-group'}>
                    <label>Produit impacté </label>
                    <select
                      name='productType'
                      value={this.state.productType ? this.state.productType.id : 'none'}
                      onChange={this.handleTicketChange}
                      className='form-control'
                    >
                      <option disabled value={'none'} />
                      {this.state.dataProductTypes ? (
                        Object.entries(
                          this.filterDealTypesByDomain(this.state.dataProductTypes, this.state.domainId)
                        ).map(([key, data]) => (
                          <option key={key} value={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>
                </Fragment>
              )}

              <div className={'form-group'}>
                <label>Fournisseur </label>
                <select
                  name='supplierOfProduct'
                  value={this.state.supplierOfProduct ? this.state.supplierOfProduct.id : 'none'}
                  onChange={this.handleTicketChange}
                  className='form-control'
                >
                  <option disabled value={'none'} />
                  {dataSuppliersVirtual && dataSuppliersHardware ? (
                    Object.entries(this.filterSupplierByDomain(dataSuppliers, domainId)).map(([key, data]) => (
                      <option key={key} value={data.id}>
                        {data.name}
                      </option>
                    ))
                  ) : (
                    <span>Chargement...</span>
                  )}
                </select>
              </div>

              {this.state.isClosed && (
                <div className='form-group'>
                  <label>Clôturé le</label>
                  <input
                    name='closingDate'
                    value={moment(this.state.closingDate).format('DD-MM-YY à HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
              )}
              {this.state.supportEmployee && (
                <InputEmployeeUpdate
                  inputType={'text'}
                  inputLabel={'Employé en charge'}
                  inputValue={this.state.supportEmployee}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'employee', 'supportEmployee')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
              )}
              <div className='form-group'>
                {this.state.status && (
                  <label
                    style={{
                      borderLeft:
                        '10px solid ' +
                        (this.state.isClosed ? 'transparent' : data_ticket_state[this.state.status].color),
                    }}
                  >
                    État
                  </label>
                )}
                {!this.state.isClosed ? (
                  <select
                    name='status'
                    value={this.state.status}
                    onChange={this.handleTicketChange}
                    className='form-control'
                  >
                    {data_ticket_state ? (
                      Object.entries(data_ticket_state).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='status'
                    value={'Clos'}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Criticité</label>
                {!this.state.isClosed ? (
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleTicketChange}
                    className='form-control'
                  >
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='criticity'
                    value={this.state.criticity + '-' + data_criticity[this.state.criticity].fr}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Priorité</label>
                {!this.state.isClosed ? (
                  <select
                    name='priority'
                    value={this.state.priority}
                    onChange={this.handleTicketChange}
                    className='form-control'
                  >
                    {data_priority ? (
                      Object.entries(data_priority).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='priority'
                    value={this.state.priority + '-' + data_priority[this.state.priority].fr}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Ouvert le</label>
                <input
                  name='dateCreate'
                  value={moment(this.state.dateCreate).format('DD-MM-YY à HH:mm')}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  readOnly
                />
              </div>
              {this.state.dateLastUpdate && (
                <div className='form-group'>
                  <label>Date de dernière modification</label>
                  <input
                    name='dateLastUpdate'
                    value={moment(this.state.dateLastUpdate).format('DD-MM-YY à HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
              )}
              {this.state.creator && (
                <div className='form-group'>
                  <label>Créateur</label>
                  <Link to={linkToUser + this.state.creator.user.id}>
                    <input
                      name='creator'
                      value={this.state.creator.user.username}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              <InputUpdate
                inputType={'text'}
                inputLabel={'URL ticket fournisseur'}
                inputValue={this.state.urlSupplierTicket}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'urlSupplierTicket')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              <TextAreaUpdate
                inputType={'text'}
                inputLabel={'Commentaire'}
                inputValue={this.state.comment}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'comment')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
            </form>
          </div>

          <MyPlanning
            onEntity={true}
            dataTask={this.state.dataTask}
            dataAppointment={this.state.dataAppointment}
            dataReminder={this.state.dataReminder}
            dataNote={this.state.dataNote}
            deleteCollaborative={this.deleteCollaborative}
          />
        </div>

        <ModalConfirm
          modalText={this.state.textModal}
          isOpen={this.state.isModalTicketChangeOpen}
          onSubmit={this.changeTicketState}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />

        <ModalTicketClose
          myTicket={triggerTicket}
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalTicketCloseOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalTaskPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostTaskOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalAppointmentPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostAppointmentOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalReminderPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostReminderOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalNotePost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostNoteOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />
      </div>
    );
  }

  openModalTicketChange(graphKey, newState) {
    let modal = {
      title: 'Ticket',
      message: "Vous allez modifiez l'état du ticket",
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalTicketChangeOpen: true,
      ticketChangeGraphKey: graphKey,
      ticketChangeNewState: newState,
    });
  }

  openModalTicketClose() {
    let modal = {
      title: 'Ticket',
      message: 'Vous allez clôturer ce ticket',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalTicketCloseOpen: true,
      appViewNavExtended: false,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalTicketChangeOpen: false,
      isModalTicketCloseOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
    });
  }

  openModal(type) {
    let toOpen = undefined;
    switch (type) {
      case 'task':
        toOpen = 'isModalPostTaskOpen';
        break;
      case 'appointment':
        toOpen = 'isModalPostAppointmentOpen';
        break;
      case 'reminder':
        toOpen = 'isModalPostReminderOpen';
        break;
      case 'note':
        toOpen = 'isModalPostNoteOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  postResult(type, promise) {
    let messageLabel = 'entité';
    switch (type) {
      case 'ticket-closing':
        messageLabel = this.state.isClosed ? 'Ticket réouvert' : 'Clôture ticket';
        break;
      case 'task':
        messageLabel = 'Succès création tâche';
        break;
      case 'appointment':
        messageLabel = 'Succès création rdv';
        break;
      case 'reminder':
        messageLabel = 'Succès création rappel';
        break;
      case 'note':
        messageLabel = 'Succès création note';
        break;
    }
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, messageLabel);
          this.componentDidMount();
        } else {
          this.props.openToast(false, 'Erreur rencontrée. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  changeTicketState() {
    if (this.props.match.params.id && this.state.ticketChangeGraphKey && this.state.ticketChangeNewState) {
      const paramsID = this.props.match.params.id;
      let queryURL = apiTicketShow;
      let graphQL =
        'mutation{ ticket(id:' +
        paramsID +
        ',' +
        this.state.ticketChangeGraphKey +
        ':' +
        this.state.ticketChangeNewState +
        ' ){ id } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['ticket']) {
              this.componentDidMount();
              this.props.openToast(true, 'Le ticket a été modifié');
            } else {
              this.props.openToast(false, 'Erreur modification ticket. Veuillez réessayer');
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            this.props.openToast(false, 'Erreur modification ticket.');
          }.bind(this)
        );
    }
  }

  closeTicket() {
    if (this.props.match.params.id) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiTicketShow;
      let graphQL = 'mutation{ ticket(id:' + paramsID + ',closed:true){ id, closed } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['ticket']['closed'] === true) {
              this.componentDidMount();
              this.props.openToast(true, 'Le ticket a été clôturé');
            } else {
              this.props.openToast(false, 'Erreur modification ticket. Veuillez réessayer');
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            console.log(rror);
            this.props.openToast(false, 'Erreur modification ticket. Veuillez réessayer');
          }.bind(this)
        );
    }
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType === 'text') {
      newValueSent = JSON.stringify(newValue);
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { ticket(id:' + this.props.match.params.id + ', ';

    let graphQuery = inputType === 'employee' ? '{ id, user{ id, username } }' : '';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + graphQuery + ' } }';

    let queryURL = apiTicketShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (fieldName === 'supportEmployee') {
            data['data']['ticket'][fieldName] = data['data']['ticket'][fieldName]['id'];
          }

          if (data['data']['ticket'][fieldName] == newValue) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            this.componentDidMount();
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE ticket entity');
        }.bind(this)
      );
  }
}

export default withAuth(DisplayTicket);
